import { Component, Input, OnInit } from '@angular/core';

import { SportConstant } from '@frontend/sports/common/core/data-access/constants';

import { NavigationRouterService } from '../../navigation/navigation-router.service';

@Component({
    selector: 'ms-horses-base',
    templateUrl: 'horses-base.component.html',
    standalone: false,
})
export class HorsesBaseComponent implements OnInit {
    @Input() sport: string;
    constructor(private navigationRouter: NavigationRouterService) {}

    ngOnInit(): void {
        if (this.sport === SportConstant.Greyhounds.toString() || this.sport === SportConstant.Horses.toString())
            this.navigationRouter.setNavigation(this.sport);
    }
}
